import { EditorSubType } from '@wix/editor-platform-sdk-types';

import { resolveEditorComponent } from '../../../resolveEditorComponent';

export type BorderPreviewProps = {
  colors?: string[];
  width?: string;
  styleKeyword?: string;
  isMixedWidth?: boolean;
  isMixedStyle?: boolean;
  emptyPreviewLabel: string;
  disabled?: boolean;
};

export default resolveEditorComponent({
  default: () => import('./variants/DefaultBorderPreview'),
  overrides: {
    [EditorSubType.Studio2]: () => import('./variants/Studio2BorderPreview'),
  },
});
